import appConfig from "@/app.config";

const schema = {
  tabs: [
    // Description
    {
      title: 'Opening Hours',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Description",
      side_panel: {},
      form: {
        description: {
          type: 'ckeditor',
          label: 'Page Description',
          placeholder: '',
          required: true,
          info: false,
          character_count: 2000,
          disabled: false,
          wrapper_class: ''
        },
        related_information: {
          type: 'checkbox',
          label: 'Related Information',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [
            {
              name: 'Practice Team',
              value: true
            },
            {
              name: 'Practice Location',
              value: false
            },
            {
              name: 'GP & Nurse Availability',
              value: true
            },
            {
              name: 'When we are Closed',
              value: false
            },
            {
              name: 'Contact Us ',
              value: false
            },
          ]
        },
      }
    },
    // Regular Hours
    {
      title: 'Opening Hours',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Regular Hours",
      side_panel: {
        location: {
          type: 'multiselect',
          label: 'Location',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        },
        days: {
          type: 'list',
          label: 'Days',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        },
        // footnote: {
        //   type: 'textarea',
        //   label: 'Footnote',
        //   placeholder: '',
        //   required: false,
        //   info: true,
        //   character_count: 0,
        //   disabled: false,
        //   wrapper_class: ''
        // },
      },
      form: {
        status: {
          type: 'checkbox',
          label: 'Status',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [
            {
              name: 'Closed',
              value: false
            },
            {
              name: 'Interim Closure',
              value: false
            }
          ]
        },
        opening_time: {
          type: 'time',
          label: 'Opening Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: "formData.status.filter(y => y.name == 'Closed')[0].value"
            }
          ]
        },
        closing_time: {
          type: 'time',
          label: 'Closing Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: 'obj.form.closed == true'
            }
          ]
        },
        second_opening_time: {
          type: 'time',
          label: 'Second Opening Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: 'obj.form.closed == true'
            },
            {
              action: 'show',
              case: "obj.form.status['Interim Closure'] == false"
            }
          ]
        },
        second_closing_time: {
          type: 'time',
          label: 'Second Closing Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: 'obj.form.closed == true'
            },
            {
              action: 'show',
              case: "obj.form.status['Interim Closure'] == false"
            }
          ]
        },
      }
    },
    // Holiday Hours
    {
      title: 'Opening Hours',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Practice Closure",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Holiday',
      formData: {},
      schema: {
      date: {
        type: 'date',
        label: 'Select Date',
        placeholder: 'Enter Date',
        required: true,
        info: true,
        character_count: 0
        },
      },
      action_buttons: {
        add_new_button: true,
        delete_button: true,
        active_button: true,
      },
      add_new_modal: {
        name: {
          type: 'date',
          label: 'Date',
          placeholder: '',
          required: true,
          info: false,
          character_count: 0
        },
      },
      side_panel: {
        location: {
          type: 'multiselect',
          label: 'Location',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        },
        dates: {
          type: 'list',
          label: 'Dates',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: []
        },
        // holiday_footnote: {
        //   type: 'textarea',
        //   label: 'Footnote',
        //   placeholder: '',
        //   required: false,
        //   info: true,
        //   character_count: 0,
        //   disabled: false,
        //   wrapper_class: ''
        // },
      },
      form: {
        date: {
          type: 'date',
          label: 'Date',
          placeholder: '',
          required: true,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6'
        },
        reduced_hours: {
          type: 'toggle',
          label: 'Reduced Hours',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6'
        },
        status: {
          type: 'checkbox',
          label: 'Status',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [
            {
              name: 'Closed',
              value: false
            },
            {
              name: 'Interim Closure',
              value: true
            }
          ]
        },
        holiday_opening_time: {
          type: 'time',
          label: 'Opening Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: 'obj.form.closed == true'
            }
          ]
        },
        holiday_closing_time: {
          type: 'time',
          label: 'Closing Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: 'obj.form.closed == true'
            }
          ]
        },
        holiday_second_opening_time: {
          type: 'time',
          label: 'Second Opening Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: 'obj.form.closed == true'
            },
            {
              action: 'show',
              case: "obj.form.status['Interim Closure'] == false"
            }
          ]
        },
        holiday_second_closing_time: {
          type: 'time',
          label: 'Second Closing Time',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          condition: [
            {
              action: 'disabled',
              case: 'obj.form.closed == true'
            },
            {
              action: 'show',
              case: "obj.form.status['Interim Closure'] == false"
            }
          ]
        },
      },
    },
  ]
};

export { schema };